<template>
  <div id="app">
    <router-view />
  </div>
</template>

<style lang="scss">
@use "~@mds/fonts-vue3/scss/config" with ($font-path: "../fonts");
@use "~@mds/fonts-vue3" as *;

body {
  margin: 0;
}

.vue-dat-gui {
  z-index: 99999;

  ul {
    max-height: 97vh !important;
  }
}

#control-panel {
  position: absolute;
  right: 0px;

  ul {
    max-height: 97vh !important;
  }
}

.version {
  position: relative;
  float: right;
  top: 0;
  z-index: 9000;
  right: 245px;
  padding: 0 6px;
  font-weight: bold;
  font-family: "MorningstarIntrinsic";
  font-size: 13px;
}

.sal-mip-portal-container {
  background-color: #ffffff;
  margin: 0 auto;
}

.sal-portal-container {
  width: 100%;
  background-color: #ffffff;
  margin: 0 auto;
  max-width: 1268px;
  min-width: 320px;
}

.version-ctrl-panel-container {
  position: sticky;
  right: 0;
  top: 0;
  height: 18px;
  z-index: 10000;
  margin: 0 10px;
}

#container-offset {
  position: sticky;
  z-index: 99;
  background-color: white;
  top: 0;
  width: 100%;
  height: 20px;
}

.research-portal-content {
  display: inline-flex;
  width: 100%;

  .sal-portal-left-panel {
    width: 240px;

    .portal-navigation {
      top: 0;
      position: sticky;
      display: block;
      width: 238px;
      height: 8537px;
      border: none;
      background: url("assets/research-portal-navigation.svg") no-repeat 0 0;
    }
  }

  .sal-portal-top-panel {
    width: 100%;

    .portal-branding {
      top: 0;
      position: sticky;
      background-color: #fff;
      display: block;
      right: 20px;
      height: 51px;
      border: none;
      background: url("assets/research-portal-branding.svg") no-repeat 0 0;
    }
  }
}

#sal-components-nav-portal {
  margin: 0;
  position: sticky;
  position: -webkit-sticky;
  top: 0;
  background-color: white;
  z-index: 900;
}
</style>
